import { PodcastProps } from 'src/components/Podcast'
import { SPodcast } from 'src/rest/types/api/Common'

import { isNotEmptyEditor } from '../../utils/Common'

import { ImageTransformer, UrlImageTransformer } from './ImageTransformer'

export function PodcastTransformer(
  podcast?: SPodcast,
  t?: any
): PodcastProps | undefined {
  if (!podcast?.audio) return undefined
  // Strapi v4 wraps media as `{ data: { attributes: {...} } }`; v5 returns
  // it flat. Unwrap each media field once so downstream transformers can read
  // the URL either way.
  const audioAny: any = podcast.audio
  const audioAttrs: any =
    audioAny?.data?.attributes ??
    audioAny?.attributes ??
    audioAny?.data ??
    audioAny
  const cover: any = (podcast.cover as any)?.data ?? podcast.cover
  const coverMobile: any =
    (podcast.coverMobile as any)?.data ?? podcast.coverMobile
  const coverImageProps = ImageTransformer(cover)
  const coverMobileImageProps = ImageTransformer(coverMobile)

  return {
    ...(audioAttrs?.url && {
      media: {
        url: UrlImageTransformer(audioAttrs.url),
        cover: {
          imageProps: coverImageProps,
          mobileImageProps: coverMobileImageProps,
        },
        title: podcast.title,
        subtitle: podcast.description,
      },
    }),
    ...(podcast.transcript &&
      isNotEmptyEditor(podcast.transcript) && {
        transcriptProps: {
          richTextProps: {
            jsonContent: podcast.transcript,
          },
          texts: {
            open: t('transcription.open'),
            close: t('transcription.close'),
          },
          open: false,
        },
      }),
    embed: podcast.embed,
    color: podcast.color,
  }
}
